import styled from 'styled-components';
import { caption, colors, spacing } from 'ui/theme';
import { Table } from './MetricsTable.styled';
import { METRICS_TABLE_TEST_IDS } from './MetricsTable.constants';
import { TableData } from './MetricsTable.types';
import { getUserFriendlyMetricLabel } from 'modules/messagingInsights/utils';
import { CAMPAIGNS_TABLE_METRICS } from '../CampaignsHealthMetrics.constants';

const TableHeader = styled(Table)`
  border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
`;

const HeaderCell = styled.div`
  ${caption}
  color: ${colors.textSecondary};
`;

const HeaderMetricNameCell = styled(HeaderCell)`
  text-align: right;
`;

export const MetricsTableHeader = ({ allTableData = [] }: { allTableData: TableData }) => {
  return (
    <TableHeader role="row">
      <HeaderCell role="columnheader">Medium</HeaderCell>
      {Object.keys(allTableData[0]?.metricsData || {})
        .sort((a, b) => {
          const aIndex = CAMPAIGNS_TABLE_METRICS.indexOf(a);
          const bIndex = CAMPAIGNS_TABLE_METRICS.indexOf(b);
          return aIndex - bIndex;
        })
        .map((metricName) => (
          <HeaderMetricNameCell
            key={metricName}
            role="columnheader"
            data-test={METRICS_TABLE_TEST_IDS.HEADER_CELL}
          >
            {getUserFriendlyMetricLabel(metricName)}
          </HeaderMetricNameCell>
        ))}
    </TableHeader>
  );
};
